module.exports = __webpack_public_path__ + "img/icon-shelly-small.944329c3.svg";